import {
  UPDATE_SETTING,
  GET_LEAD_STATUS,
  ADD_LEAD_STATUS,
  UPDATE_LEAD_STATUS,
  DELETE_LEAD_STATUS,
  GET_SETTING,
  CREATE_WHATSAPP_MESSAGE,
  GET_ALL_WHATSAPP_MESSAGE,
  DELETE_WHATSAPP_MESSAGE,
  UPDATE_WHATSAPP_MESSAGE,
  GET_WHATSAPP_BYID,
  GET_ALL_MESSAGE,
  CREATE_VOICE_AI_DETAILS,
  UPDATE_VOICE_AI_DETAILS,
  GET_VOICE_AI_DETAILS,
  GET_VOICE_AI_STATUS,
  CREATE_VOICE_AI_STATUS,
  UPDATE_VOICE_AI_STATUS,
  DELETE_VOICE_AI_STATUS,
} from '../actions/Setting.action';

const initialState = {
  updateSetting: '',
  getSetting: '',
  leadStatuses: [],
  totalPages: 1,
  createWhatsAppMessage: '',
  getAllWhatsAppMessage: '',
  deleteWhatsAppMessage: '',
  updateWhatsAppMessage: '',
  getWhatsAppById: '',
  getAllMessage: '',
  voiceAIDetails: {},
  voiceAIStatus: [],
};

const settingreducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SETTING:
      return { ...state, updateSetting: action.payload };
    case GET_SETTING:
      return { ...state, getSetting: action.payload };
    case GET_LEAD_STATUS:
      console.log('GET_LEAD_STATUS payload:', action.payload);
      return {
        ...state,
        leadStatuses: action.payload.leadStatuses,
        totalPages: action.payload.totalPages,
      };
    case ADD_LEAD_STATUS:
      return {
        ...state,
        leadStatuses: [...state.leadStatuses, action.payload],
      };
    case UPDATE_LEAD_STATUS:
      return {
        ...state,
        leadStatuses: state.leadStatuses.map((status) =>
          status._id === action.payload._id ? action.payload : status,
        ),
      };
    case DELETE_LEAD_STATUS:
      return {
        ...state,
        leadStatuses: state.leadStatuses.filter(
          (status) => status._id !== action.payload,
        ),
      };

    case CREATE_WHATSAPP_MESSAGE:
      return { ...state, createWhatsAppMessage: action.payload };
    case GET_ALL_WHATSAPP_MESSAGE:
      return { ...state, getAllWhatsAppMessage: action.payload };
    case DELETE_WHATSAPP_MESSAGE:
      return { ...state, deleteWhatsAppMessage: action.payload };
    case UPDATE_WHATSAPP_MESSAGE:
      return { ...state, updateWhatsAppMessage: action.payload };
    case GET_WHATSAPP_BYID:
      return { ...state, getWhatsAppById: action.payload };
    case GET_ALL_MESSAGE:
      return { ...state, getAllMessage: action.payload };

    case CREATE_VOICE_AI_DETAILS:
      return { ...state, voiceAIDetails: action.payload };
    case UPDATE_VOICE_AI_DETAILS:
      return { ...state, voiceAIDetails: action.payload };
    case GET_VOICE_AI_DETAILS:
      return { ...state, voiceAIDetails: action.payload };

    case GET_VOICE_AI_STATUS:
      return { ...state, voiceAIStatus: action.payload };
    case CREATE_VOICE_AI_STATUS:
      return {
        ...state,
        voiceAIStatus: [...state.voiceAIStatus, action.payload],
      };
    case UPDATE_VOICE_AI_STATUS:
      return {
        ...state,
        voiceAIStatus: state.voiceAIStatus.map((item) =>
          item._id === action.payload._id ? action.payload : item,
        ),
      };
    case DELETE_VOICE_AI_STATUS:
      return {
        ...state,
        voiceAIStatus: state.voiceAIStatus.filter(
          (item) => item._id !== action.payload,
        ),
      };

    default:
      return state;
  }
};

export default settingreducer;
